<app-carousel-promotional-profile [diviceXs]="diviceXs" [diviceSm]="diviceSm">
</app-carousel-promotional-profile>


<mat-toolbar>
    <button id="btn-menu" mat-icon-button (click)="sidenav.toggle()">
    <span class="material-icons"> menu </span>
  </button>

    <div id="titleName">
        <h2>Mi cuenta</h2>
        <p>¡Hola! {{firebaseAuthService.displayNameObs| async}}</p>
    </div>
</mat-toolbar>


<mat-drawer-container class="example-container" [hasBackdrop]="diviceXs || diviceSm">

    <mat-drawer [mode]="!diviceXs && !diviceSm ? 'side' : 'over'" [opened]="!diviceXs && !diviceSm" #sidenav>
        <app-slider-menu></app-slider-menu>
    </mat-drawer>

    <mat-drawer-content>
        <div id="summary">

            <h1>Resumen</h1>

            <div id="contentSummary" fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-between center" fxLayoutAlign.xs="space-around center">

                <div id="colum-1" fxFlex="50" fxFlex.xs="100">
                    <div id="headerSummary" fxLayout="row" fxLayoutAlign="start center">
                        <span class="material-icons-outlined">shopping_bag</span>
                        <h2>Mis Compras</h2>
                    </div>

                    <div id="bodySummary">
                        <div id="purchasesInTheMonth" fxLayout="row" fxLayoutAlign="start center">
                            <h3 fxFlex="10" fxFlex.xs="30">{{purchasesInTheMonth}}</h3>
                            <!-- <p>Compras realizadas en <span id="mount">{{todayDate | date:'MMMM':'es'}}</span></p> -->
                            <p>Compras realizadas en los últimos <span id="mount"> {{periodInDays}}</span> días</p>
                        </div>

                        <div id="pointsForReferrals" fxLayout="row" fxLayoutAlign="start center">
                            <h3 fxFlex="10" fxFlex.xs="30">{{pointsForReferrals}}</h3>
                            <p>Puntos por tus referidos</p>
                        </div>

                        <div id="shoppingPointsMonth" fxLayout="row" fxLayoutAlign="start center">
                            <h3 fxFlex="10" fxFlex.xs="30">{{shoppingPointsMonth}}</h3>
                            <p>Puntos por tus compras este periodo</p>
                        </div>

                        <div id="periodSpentPoints" fxLayout="row" fxLayoutAlign="start center">
                            <h3 fxFlex="10" fxFlex.xs="30">{{spentPoints}}</h3>
                            <p>Puntos redimidos</p>
                        </div>
                    </div>
                </div>

                <div id="colum-2" fxFlex="40" fxFlex.xs="100">

                    <div id="infoPoints" fxLayout="row" fxLayoutAlign="space-around center">
                        <div id="gessiPoints">
                            <h2>Gessi Puntos</h2>
                            <p>{{gessiPoints}} Gessis</p>

                            <a href="">Ver mis referidos</a>
                        </div>

                        <div id="gessiPointsToBeat">
                            <h4>Tus puntos vencen luego de:</h4>
                            <p>{{daysToExpire}} días</p>

                            <a href="">Ver mis beneficios</a>
                        </div>
                    </div>

                    <div id="news">
                        <h2>Novedades</h2>
                        <ul>
                            <li>Conoce las <a href="">nuevas tarifas para publicar tu vehículo</a> a partir del 7 de abril.</li>
                            <li>Cambiamos los costos de los envíos gratis. <a href="">Conocer más</a>.</li>
                        </ul>
                    </div>

                </div>

            </div>

        </div>
    </mat-drawer-content>
</mat-drawer-container>



<!-- <div class="contentMainProfile">





</div> -->